export const UNHANDLED_BANK_PAYMENTS_REPORT_UPDATED = "UNHANDLED_BANK_PAYMENTS_REPORT_UPDATED";
export const UNHANDLED_BANK_PAYMENTS_REPORT_COMPLETED = "UNHANDLED_BANK_PAYMENTS_REPORT_COMPLETED";
